import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/DriversVehicleHero")
);

const VehicleHeroEditConfig = {
  emptyLabel: "Drivers Vehicle Hero",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const VehicleHero = (props) => {
  return <Component {...props} />;
};

export default withAemIntegration("lexus/components/drivers/vehicle-hero")(
  VehicleHero,
  VehicleHeroEditConfig
);
